<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2" title="Title Page"></h2>
<p class="tp2">Called to Be Saints</p>
<p class="tp3">An Invitation to Christian Maturity</p>
<div class="chding"><img alt="chdingbat.jpg" class="author" src="Images/TP_graphic.jpg"/></div>
<p class="tp3">Gordon T. Smith</p>
<p class="first"><br/></p>
<p class="tp2"><span class="sgc-2"><img alt="IVP Academic Imprint" src="Images/IVP_Academic_Quarter.jpg"/></span></p>
<p class="center"><a href="http://www.IVPress.com/academic/" target="_blank">www.IVPress.com/academic</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?350d2efc